define('admin/teams/invite',['jquery', 'plugins/http', 'knockout', 'durandal/app'], function($, http, ko, app) {
    var viewmodel = function() {
        var self = this;
        
        self.teams = ko.observableArray([]);
        self.inviteEmail = ko.observable();
        self.invitePassword = ko.observable();
        self.selectedTeams = ko.observableArray();
        self.inviteIsAdmin = ko.observable(false);
        self.errormessage = ko.observable();

        self.activate = function (goBackFunc) {
            self.exit = goBackFunc;
            self.refreshTeams();
        };
        
        self.refreshTeams = function () {
            self.teams.removeAll();

            self.getTeamsForCompany()
                .then(self.processTeams)
                .fail(app.showError);
        };
        
        self.processTeams = function (response) {
            var teams = response.data.teams,
                spliceArgs = [0, 0].concat(teams);

            self.teams.splice.apply(self.teams, spliceArgs);
        };

        self.clearForm = function () {
            self.inviteEmail('');
            self.inviteIsAdmin(false);
            self.selectedTeams.removeAll();
            $("[id^='teams-']").attr('checked', false);
        };
        
        self.toggleInviteeTeam = function (team, e) {
            var checkBox = $(e.target),
                isChecked = checkBox.is(':checked');

            if (isChecked && self.selectedTeams.indexOf(team) === -1) {
                self.selectedTeams.push(team.id);
            } else if (!isChecked && self.selectedTeams.indexOf(team) >= 0) {
                self.selectedTeams.remove(team.id);
            }

            return true;
        };

        self.inviteUser = function () {
            var invite = {
                email: self.inviteEmail(),
                teamIds: self.selectedTeams(),
                isCompanyAdmin: self.inviteIsAdmin(),
                password: self.invitePassword()
            };

            if (!invite.email) {
                app.showMessage('Email cannot be empty');
                return;
            } else if (!invite.teamIds.length) {
                app.showMessage('The user must be invited to at least 1 team');
                return;
            }

            if (invite.password) {
                self.createUser(invite)
                    .then(self.processCreateUser)
                    .fail(app.showError);
            }
            else {
                self.saveInvite(invite)
                    .then(function () {
                        self.clearForm();
                        self.exit();
                    })
                    .fail(app.showError);
            }

        };
        
        self.getTeamsForCompany = function () {
            var url = '/api/admin/teams/list';

            return http.get(url);
        };

        self.processCreateUser = function (response) {
            if (response.error) {
                self.errormessage(response.error);
            }
            else {
                self.clearForm();
                self.exit();
            }
        };
        
        self.saveInvite = function (invite) {
            var url = '/api/admin/teams/users/invite';

            return http.post(url, invite);
        };

        self.createUser = function (invite) {
            var url = '/api/auth/createaccount';

            return http.post(url, invite);
        };

        self.cancelInvite = function () {
            self.clearForm();
            self.exit();
        };
    };

    return viewmodel;
});

